import { ChangeDetectionStrategy, Component, inject, OnInit, computed, signal, ViewChildren, QueryList, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MedarbejderComponent } from './medarbejder/medarbejder.component';
import { MedarbejdereGrupperModal } from './medarbejdere-grupper-modal/medarbejdere-grupper-modal';
import { MedarbejdereAfdelingerModal } from './medarbejdere-afdelinger-modal/medarbejdere-afdelinger-modal';
import { IndexCardsStore } from './indexcards.store';
import { MedarbejdereNormtiderModal } from './medarbejdere-normtider-modal/medarbejdere-normtider-modal';

@Component({
    selector: 'app-medarbejdere',
    templateUrl: './medarbejdere.component.html',
    styleUrls: ['./medarbejdere.component.scss'],
    // Scoped by .employee-modal; styles also reach ng-select and the modal wrapper.
    encapsulation: ViewEncapsulation.None,
    host: { class: 'd-flex flex-column' },
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MedarbejdereComponent implements OnInit {
    readonly indexCardsStore = inject(IndexCardsStore);
    private readonly activeModal = inject(NgbActiveModal);
    private readonly modalService = inject(NgbModal);

    readonly users = this.indexCardsStore.users;

    readonly search = signal('');
    readonly rateColumns = this.indexCardsStore.rateColumns;

    readonly showAll = signal(false);

    readonly sortedUsers = computed(() => {
        const currentUsers = this.users() || [];
        const showingAll = this.showAll();

        return [...currentUsers]
            .filter(user => showingAll || !user.fratraadt)
            .filter(user => [user.brugerId, user.fornavn, user.efternavn, user.email].join(' ').toLocaleLowerCase('da').includes(this.search().trim().toLocaleLowerCase('da')))
            .sort((a, b) => a.brugerId.localeCompare(b.brugerId));
    });

    @ViewChildren(MedarbejderComponent) rows!: QueryList<MedarbejderComponent>;

    closeDropdowns(): void {
        this.rows?.forEach(row => row.closeDropdowns());
    }

    ngOnInit(): void {
        this.indexCardsStore.init();
    }

    onDismiss(): void {
        this.activeModal.close();
    }

    changeShowAll(): void {
        this.showAll.update(val => !val);
    }

    normTiderPopup(): void {
        this.modalService.open(MedarbejdereNormtiderModal, {
            size: 'xl',
            windowClass: 'employee-modal',
            scrollable: true
        });
    }

    afdelingerPopup(): void {
        this.modalService.open(MedarbejdereAfdelingerModal, {
            size: 'md',
            scrollable: true,
            centered: true
        });
    }

    grupperPopup(): void {
        this.modalService.open(MedarbejdereGrupperModal, {
            size: 'md',
            scrollable: true,
            centered: true
        });
    }
}
